export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  color: string;
}

export const categories: Category[] = [
  {
    slug: "entertainment",
    name: "娱乐爆料",
    description: "娱乐圈最新最劲爆的独家内幕，明星八卦、综艺黑幕、饭圈真相全在这里",
    icon: "ri-movie-2-line",
    count: 5,
    color: "accent",
  },
  {
    slug: "business",
    name: "商业内幕",
    description: "揭开商业世界不为人知的黑暗面，企业内斗、财务造假、资本运作全揭露",
    icon: "ri-building-2-line",
    count: 4,
    color: "primary",
  },
  {
    slug: "workplace",
    name: "职场黑料",
    description: "打工人必看的职场真相，加班压榨、职场歧视、劳动纠纷一网打尽",
    icon: "ri-briefcase-line",
    count: 3,
    color: "secondary",
  },
  {
    slug: "social",
    name: "社会热点",
    description: "聚焦社会民生的重大爆料，食品安全、教育乱象、医疗腐败持续追踪",
    icon: "ri-global-line",
    count: 4,
    color: "accent",
  },
  {
    slug: "tech",
    name: "科技揭秘",
    description: "科技行业背后的秘密，数据造假、算法操控、技术泄密深度调查",
    icon: "ri-cpu-line",
    count: 4,
    color: "primary",
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((cat) => cat.slug === slug);
};